import { BaseConfirmationDialog } from '@plato/ui-legacy/components/dialog/confirmation-dialog';
import { DialogStateManager, useDialog } from '@plato/ui-legacy/components/dialog/dialog-provider';
import { RadioList, RadioListItem } from '@plato/ui-legacy/components/ui/button-radio-list';
import { CalendarIcon } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import type { ModalInnerProps } from '../../modal/index.tsx';

export type RecurrenceEditScope = 'single' | 'following';

export type RecurrenceScopeDialogProps = {
    onConfirm: (scope: RecurrenceEditScope) => void;
    onCancel?: () => void;
} & ModalInnerProps;

export const RecurrenceScopeDialog = DialogStateManager.create<RecurrenceScopeDialogProps>(
    ({ onConfirm, onCancel }: RecurrenceScopeDialogProps) => {
        const { t } = useTranslation();
        const modal = useDialog();
        const [scope, setScope] = React.useState<RecurrenceEditScope>('single');

        const handleConfirm = () => {
            onConfirm(scope);
            modal.remove();
        };

        const handleCancel = () => {
            onCancel?.();
            modal.remove();
        };

        return (
            <BaseConfirmationDialog
                title={t('events__recurrence_scope__title', { ns: 'events' })}
                description={t('events__recurrence_scope__body', { ns: 'events' })}
                icon={CalendarIcon}
            >
                <div className="self-start">
                    <RadioList
                        value={scope}
                        onValueChange={(val) => {
                            setScope(val as RecurrenceEditScope);
                        }}
                    >
                        <RadioListItem
                            value="single"
                            label={t('events__recurrence_scope__single', { ns: 'events' })}
                        />
                        <RadioListItem
                            value="following"
                            label={t('events__recurrence_scope__following', { ns: 'events' })}
                        />
                    </RadioList>
                </div>
                <BaseConfirmationDialog.Actions>
                    <BaseConfirmationDialog.RejectButton onClick={handleCancel}>
                        {t('form__cancel')}
                    </BaseConfirmationDialog.RejectButton>
                    <BaseConfirmationDialog.AcceptButton onClick={handleConfirm}>
                        {t('events__recurrence_scope__confirm', { ns: 'events' })}
                    </BaseConfirmationDialog.AcceptButton>
                </BaseConfirmationDialog.Actions>
            </BaseConfirmationDialog>
        );
    },
);
